import axios from 'axios';
import router from '../components/routing/router';
import { TimeSpan, ToasterType } from '../components/providers/toaster-provider';

var requestInterceptor: any | null = null;
var responseInterceptor: any | null = null;

export const initializeAxiosInterceptors = (props: { openToaster: (message: string, timeSpan: TimeSpan, type: ToasterType) => void }) => {

    if (!requestInterceptor) {
        // Add a request interceptor
        requestInterceptor = axios.interceptors.request.use(async function (config) {
            var token = localStorage.getItem('auth_token');

            if (!token) {
                await new Promise(resolve => setTimeout(resolve, 100));

                token = localStorage.getItem('auth_token');
            }

            config.params = config.params || {};

            if (token && config && config.params && !config.params?.token) {
                config.params = { ...config.params, ...{ 'token': token }, ...{ 'context': 'supplier' } };
            }

            return config;
        }, function (error) {
            // Do something with request error
            return Promise.reject(error);
        });
    }

    if (!responseInterceptor) {
        // Add a response interceptor
        responseInterceptor = axios.interceptors.response.use(function (response) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            // Do something with response data
            return response;
        }, async function (error) {
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            switch (error?.response?.status) {
                case 401:
                    
                    if (!window.location.href.includes('login')) {
                        localStorage.removeItem('auth_token');
                        router.navigate('/login');
                        props.openToaster('Login expired. Please login again.', 'medium', 'error');
                    } else {
                        // props.openToaster('Email or password is incorrect. Please try again.', 'medium', 'error');
                    }

                    break;
                case 404:
                    props.openToaster('The target is offline of unavailable. Please try again later.', 'medium', 'error');

                    break;
                case 500:
                    props.openToaster('Something went wrong. Please try again.', 'medium', 'error');

                    break;
            }

            return Promise.reject(error);
        });
    }
};
